import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { ProtectedRoute } from '../components/Common';

const HomePage = React.lazy(() => import('../pages/Home'));
const RoadmapPage = React.lazy(() => import('../pages/Roadmap'));
const ContentPersonal = React.lazy(() => import('../pages/ContentPersonal'));
const ContentEnterprise = React.lazy(() => import('../pages/ContentEnterprise'));
const CreativeStudio = React.lazy(() => import('../pages/CreativeStudio'));
const AnalyticsPage = React.lazy(() => import('../pages/Analytics'));
const RewritePage = React.lazy(() => import('../pages/Copywriting'));
const MixerPage = React.lazy(() => import('../pages/SmartMix'));
const DramaPage = React.lazy(() => import('../pages/IPGene'));
const ProfilePage = React.lazy(() => import('../pages/Profile'));
const CloudSpacePage = React.lazy(() => import('../pages/CloudSpace'));
const NotificationListPage = React.lazy(() => import('../pages/Notifications').then(m => ({ default: m.NotificationListPage })));
const NotificationDetailPage = React.lazy(() => import('../pages/Notifications').then(m => ({ default: m.NotificationDetailPage })));
const MusicPage = React.lazy(() => import('../pages/Music'));
const TermsPage = React.lazy(() => import('../pages/Legal').then(m => ({ default: m.TermsPage })));
const PrivacyPage = React.lazy(() => import('../pages/Legal').then(m => ({ default: m.PrivacyPage })));
const PersonalTemplateLibraryPage = React.lazy(() => import('../pages/PersonalTemplateLibrary'));
const BusinessTemplateLibraryPage = React.lazy(() => import('../pages/BusinessTemplateLibrary'));
const BusinessBrandPage = React.lazy(() => import('../pages/BusinessBrand'));
const BusinessCopyPage = React.lazy(() => import('../pages/BusinessCopy'));
const BusinessVideoPage = React.lazy(() => import('../pages/BusinessVideo'));
const BusinessAnalyticsPage = React.lazy(() => import('../pages/BusinessAnalytics'));
const BusinessAnalysisPage = React.lazy(() => import('../pages/BusinessAnalysis'));
const BusinessCRMPage = React.lazy(() => import('../pages/BusinessCRM'));
const UpgradeServicePage = React.lazy(() => import('../pages/UpgradeService'));

const PageLoader = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-dark-bg">
    <div className="w-10 h-10 border-2 border-luxury-gold/30 border-t-luxury-gold rounded-full animate-spin" />
  </div>
);

const TemplateLibraryRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const mode = localStorage.getItem('ui_mode') || 'personal';
    const targetPath = mode === 'business' ? '/templates/business' : '/templates/personal';
    navigate(targetPath, { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-dark-bg">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-orange-400/30 border-t-orange-400 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white text-lg">正在跳转到模板库...</p>
      </div>
    </div>
  );
};

const AppRoutes = ({
  onLoginClick,
  isLoggedIn,
  user,
  onLogout,
  onUserUpdate,
  formatRelativeTime,
  formatExactTime,
  markNotificationRead,
  renderNotifIcon,
  globalNotifications,
  notifUnreadCount,
  notifSoundEnabled,
  setNotifSoundEnabled,
  refreshNotifications
}) => {
  return (
    <React.Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<HomePage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} unreadCount={notifUnreadCount} notifications={globalNotifications} formatRelativeTime={formatRelativeTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />} />
        <Route path="/roadmap" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <RoadmapPage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} notifUnreadCount={notifUnreadCount} globalNotifications={globalNotifications} formatRelativeTime={formatRelativeTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />
          </ProtectedRoute>
        } />
        <Route path="/content" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <TemplateLibraryRedirect />
          </ProtectedRoute>
        } />
        <Route path="/work" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <CreativeStudio onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} />
          </ProtectedRoute>
        } />
        <Route path="/templates/personal" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <PersonalTemplateLibraryPage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} unreadCount={notifUnreadCount} notifications={globalNotifications} formatRelativeTime={formatRelativeTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />
          </ProtectedRoute>
        } />
        <Route path="/templates/business" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <BusinessTemplateLibraryPage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} unreadCount={notifUnreadCount} notifications={globalNotifications} formatRelativeTime={formatRelativeTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />
          </ProtectedRoute>
        } />
        <Route path="/content/personal" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <ContentPersonal onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} notifUnreadCount={notifUnreadCount} globalNotifications={globalNotifications} formatRelativeTime={formatRelativeTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />
          </ProtectedRoute>
        } />
        <Route path="/content/enterprise" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <ContentEnterprise onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} notifUnreadCount={notifUnreadCount} globalNotifications={globalNotifications} formatRelativeTime={formatRelativeTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />
          </ProtectedRoute>
        } />
        <Route path="/cloud" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <CloudSpacePage user={user} onLogout={onLogout} unreadCount={notifUnreadCount} notifications={globalNotifications} formatRelativeTime={formatRelativeTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />
          </ProtectedRoute>
        } />
        <Route path="/analytics" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <AnalyticsPage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} notifUnreadCount={notifUnreadCount} globalNotifications={globalNotifications} formatRelativeTime={formatRelativeTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />
          </ProtectedRoute>
        } />
        <Route path="/rewrite" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <RewritePage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} notifUnreadCount={notifUnreadCount} globalNotifications={globalNotifications} formatRelativeTime={formatRelativeTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />
          </ProtectedRoute>
        } />
        <Route path="/account" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <UpgradeServicePage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} unreadCount={notifUnreadCount} notifications={globalNotifications} formatRelativeTime={formatRelativeTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />
          </ProtectedRoute>
        } />
        <Route path="/mixer" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <MixerPage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} notifUnreadCount={notifUnreadCount} globalNotifications={globalNotifications} formatRelativeTime={formatRelativeTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />
          </ProtectedRoute>
        } />
        <Route path="/drama" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <DramaPage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} notifUnreadCount={notifUnreadCount} globalNotifications={globalNotifications} formatRelativeTime={formatRelativeTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />
          </ProtectedRoute>
        } />
        <Route path="/music" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <MusicPage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} notifUnreadCount={notifUnreadCount} globalNotifications={globalNotifications} formatRelativeTime={formatRelativeTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />
          </ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <ProfilePage user={user} onLogout={onLogout} onUserUpdate={onUserUpdate} unreadCount={notifUnreadCount} notifSoundEnabled={notifSoundEnabled} setNotifSoundEnabled={setNotifSoundEnabled} formatRelativeTime={formatRelativeTime} formatExactTime={formatExactTime} globalNotifications={globalNotifications} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} refreshNotifications={refreshNotifications} />
          </ProtectedRoute>
        } />
        <Route path="/myspace" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <CloudSpacePage user={user} onLogout={onLogout} unreadCount={notifUnreadCount} notifications={globalNotifications} formatRelativeTime={formatRelativeTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />
          </ProtectedRoute>
        } />
        <Route path="/notifications" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <NotificationListPage user={user} onLogout={onLogout} unreadCount={notifUnreadCount} notifications={globalNotifications} formatRelativeTime={formatRelativeTime} formatExactTime={formatExactTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />
          </ProtectedRoute>
        } />
        <Route path="/notifications/:id" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <NotificationDetailPage user={user} onLogout={onLogout} unreadCount={notifUnreadCount} notifications={globalNotifications} formatRelativeTime={formatRelativeTime} formatExactTime={formatExactTime} markNotificationRead={markNotificationRead} renderNotifIcon={renderNotifIcon} />
          </ProtectedRoute>
        } />
        <Route path="/business/brand" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <BusinessBrandPage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} />
          </ProtectedRoute>
        } />
        <Route path="/business/copy" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <BusinessCopyPage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} />
          </ProtectedRoute>
        } />
        <Route path="/business/video" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <BusinessVideoPage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} />
          </ProtectedRoute>
        } />
        <Route path="/business/analytics" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <BusinessAnalyticsPage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} />
          </ProtectedRoute>
        } />
        <Route path="/business/analysis" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <BusinessAnalysisPage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} />
          </ProtectedRoute>
        } />
        <Route path="/business/crm" element={
          <ProtectedRoute isLoggedIn={isLoggedIn} onLoginClick={onLoginClick}>
            <BusinessCRMPage onLoginClick={onLoginClick} isLoggedIn={isLoggedIn} user={user} onLogout={onLogout} />
          </ProtectedRoute>
        } />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Routes>
    </React.Suspense>
  );
};

export default AppRoutes;
